import styled from "styled-components";

const ActionArea = styled.div`
  margin-top: 20px;
`;
export default ActionArea;
